<div *ngIf="canAddDocument" class="container" uploadDocumentDirective (fileDropped)="onFileDropped($event)">
	<input
		[disabled]="isFilesLoading"
		type="file"
		#fileDropRef
		id="fileDropRef"
		multiple
		(change)="fileBrowseHandler($event.target.files)"
		[accept]="filesTypes"
	/>
	<i class="fas fa-cloud-upload doc-upload-ico"></i>
	<h5>Glissez et déposez le fichier ici ou <label for="fileDropRef"> Parcourir le fichier</label></h5>
</div>

<div class="chips-extended" *ngIf="viewDocumentChips">
	<!-- // Liste des fichier qui sont deja dans alfresco -->
	<div class="chips-extended-items" *ngFor="let item of alfrescoFiles">
		<div class="chips-extended-items-actions">
			<span>
				{{ item?.name }}
			</span>

			<!-- We use i for workaround problem with button tag, which emits closing popup coordonneeBancaire-->
			<i (click)="deleteAlfrescoFile(item.id)" class="button-i fa fa-times"></i>
		</div>
	</div>

	<div *ngIf="canAddDocument">
		<div class="chips-extended-items" *ngFor="let file of files; let i = index">
			<div class="chips-extended-items-actions">
				<span class="text">
					{{ file?.name }}
				</span>

				<button class="button" (click)="deleteFile(i)"><i class="fa fa-times"></i></button>
			</div>
		</div>
	</div>
</div>
